import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  /* align-items: center; */
`;
type LabelButtonProps = {
  isFileSelected: boolean;
};

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0px;
  }

  label {
    font-style: normal;
    font-weight: normal;
    font-size: 0.9rem;
    color: var(--grey-100);
    margin-bottom: 12px;
  }
`;

export const LabelButton = styled.div<LabelButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  /* width: 60%; */
  background-color: var(--black-300);
  border-radius: 10px;
  cursor: pointer;
  border: 2px dashed var(--grey-300);
  
  position: relative;

  input {
    display: none;
  }

  p {
    max-width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.9rem;
  }

  span {
    color: var(--grey-100);

    margin-bottom: 1.4rem;
    margin-top: 0.5rem;
  }

  transition: opacity 0.3s;

  &:hover {
    opacity: 0.7;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      margin-top: 0.8rem;
    }
  }
  ${({ isFileSelected }) =>
    isFileSelected &&
    css`
      background-color: var(--black-400);
    `};
`;

export const Column = styled.div`
  display: flex;
  /* align-items: center; */
  flex-direction: column;
  width: 100%;
  padding: 2rem;
  height: 100%;

  &:first-of-type {
    border-right: 1px solid #3d3d3d;
  }
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 100%;

  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  opacity: 0.1;

  object-fit: cover;

  position: absolute;
`;
